import { createComponent, createHook } from 'reakit-system';
import { BoxHTMLProps, BoxProps, useBox } from '../Box/Box';
import pxToRem from '../utils/pxToRem';

export const ISLAND_SPACE = ['sp-8', 'sp-16'];
export const ISLAND_WRAPPER_PADDING = [
  'sp-0',
  'sp-16',
  'sp-24',
  'sp-32',
  pxToRem(33),
  pxToRem(36),
] as BoxProps['px'];

export type IslandOptions = {
  size?: 'size-1' | 'size-2' | 'size-3';
} & Omit<BoxProps, 'width' | 'borderRadius' | 'size'>;

const useIsland = createHook<IslandOptions, BoxHTMLProps>({
  compose: [useBox],
  useOptions({ size, ...options }) {
    let maxWidth: BoxProps['width'] = 1;

    if (size === 'size-1') maxWidth = pxToRem(736);
    if (size === 'size-2') maxWidth = pxToRem(1136);
    if (size === 'size-3') maxWidth = pxToRem(1528);

    return {
      px: ['sp-16', 'sp-40'],
      pb: ['sp-24', 'sp-40'],
      pt: ['sp-24', 'sp-32'],
      backgroundColor: 'white',
      ...options,
      width: '100%',
      maxWidth,
      borderRadius: [pxToRem(16), pxToRem(24)],
    };
  },
});

const Island = createComponent({
  as: 'div',
  useHook: useIsland,
  memo: true,
});

export { Island, useIsland };
